import { clsx } from 'clsx'

import { BillingAddress } from '@/components/DisplayAddress/BillingAddress'

import styles from '../SearchAddress.module.scss'

interface DeliveryAddressItemProps {
  address?: {
    partnerNumber?: string
    [key: string]: unknown
  }
  value?: {
    partnerNumber?: string
    [key: string]: unknown
  }
  onChange?: (address: { partnerNumber?: string }) => void
}

const DeliveryAddressItem = ({
  address,
  value,
  onChange,
}: DeliveryAddressItemProps) => {
  return (
    <div key={address?.partnerNumber} className={styles.address}>
      <div
        aria-hidden="true"
        className={clsx(
          styles.addressInner,
          value?.partnerNumber === address?.partnerNumber
            && styles.addressSelected,
        )}
        onClick={() => onChange?.(address)}
      >
        <BillingAddress data={address} />
      </div>
    </div>
  )
}

export default DeliveryAddressItem
